import { Button, ButtonProps } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { useAuth } from "./useAuth.js";

interface Props {
  variant?: ButtonProps["variant"];
  color?: ButtonProps["color"];
}

export const ResetPasswordButton = ({
  variant = "contained",
  color = "primary",
}: Props) => {
  const { auth } = useAuth();
  const { t } = useTranslate(["LoginForm"]);

  return (
    <Button
      variant={variant}
      color={color}
      disableElevation
      fullWidth
      onClick={() => {
        auth.login({
          action: "UPDATE_PASSWORD",
        });
      }}
    >
      {t("Reset password", { ns: "LoginForm" })}
    </Button>
  );
};
